<template>
  <b-form-group label="Fecha">
      <date-picker
        v-model="rangeDate"
        lang="es"
        format="DD-MM-YYYY"
        range
        confirm
      ></date-picker>
  </b-form-group>
</template>
<script>
import flatPickr from 'vue-flatpickr-component'
import { mapActions, mapMutations } from 'vuex'
import { BInputGroup, BFormGroup } from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  components: {
    flatPickr,
    BFormGroup,
    BInputGroup,
    DatePicker,
  },
  data() {
    return {}
  },
  computed: {
    rangeDate: {
      get() {
        return this.$store.state.tableFilters.date
      },
      set(value) {
        this.setDate(value)
        this.$emit('getLocations')
      },
    },
    pageQuantity() {
      return this.$store.state.tableFilters.pageQuantity
    },
    offset() {
      return this.$store.state.tableFilters.offset
    },
  },
  methods: {
    ...mapMutations('tableFilters', ['setDate']),
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
